module.exports = __webpack_public_path__ + "img/6.33dcdf9b.png";